export var DiscountBadgeShape;
(function (DiscountBadgeShape) {
    DiscountBadgeShape["Rectangle"] = "rectangle";
    DiscountBadgeShape["RoundedRectangle"] = "roundedRectangle";
    DiscountBadgeShape["Circle"] = "circle";
    DiscountBadgeShape["Pill"] = "pill";
})(DiscountBadgeShape || (DiscountBadgeShape = {}));
